/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Tysiav2PaymentTransferIcon/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Tysiav2PaymentTransferIcon({
  children,
  viewPath = "/DesignSystem/Svgs/Tysiav2PaymentTransferIcon",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 12,
  height = 10,
  fill = "none",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill2 = "#166086"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="Tysiav2PaymentTransferIcon.Svg"
  data-view-path={viewPath}
 viewBox="0 0 12 10"
 style={{'--as-1-Z16GzhH': alignSelf,'--mt-2-Z16GzhH': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-Z16GzhH': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-Z16GzhH': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-Z16GzhH': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-Z16GzhH': opacity,'--w-10-Z16GzhH': typeof width === 'number' ? `${width}px` : width,'--h-11-Z16GzhH': typeof height === 'number' ? `${height}px` : height,'--f-12-Z16GzhH': fill,'--a-7-Z16GzhH': isAnimated ? animation : "none",'--sd-8-Z16GzhH': isAnimated ? strokeDashoffset : 0,'--sd-9-Z16GzhH': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="Tysiav2PaymentTransferIcon.SvgPath"
  data-view-path={viewPath}
 fillRule="evenodd"
 clipRule="evenodd"
 d="M8.193.032a.438.438 0 01.467.09l1.286 1.25a.409.409 0 010 .59L8.66 3.211a.438.438 0 01-.467.09.417.417 0 01-.264-.385v-.625H1.5a.211.211 0 00-.214.208v4.167a.634.634 0 01-.643.625A.634.634 0 010 6.667V2.5c0-.805.672-1.458 1.5-1.458h6.429V.417c0-.169.104-.32.264-.385zM6 6.667c.947 0 1.714-.747 1.714-1.667S6.947 3.333 6 3.333 4.286 4.08 4.286 5 5.053 6.667 6 6.667zM2.589 4.583a.634.634 0 00-.643.625c0 .345.288.625.643.625.354 0 .642-.28.642-.625a.634.634 0 00-.642-.625zm6.18.625c0-.345.287-.625.642-.625.355 0 .643.28.643.625a.634.634 0 01-.643.625.634.634 0 01-.642-.625zm2.588-2.5c.355 0 .643.28.643.625V7.5c0 .805-.672 1.458-1.5 1.458H4.071v.625c0 .169-.104.32-.264.385a.438.438 0 01-.467-.09l-1.286-1.25a.409.409 0 010-.59l1.286-1.25a.438.438 0 01.467-.09c.16.065.264.217.264.385v.625H10.5a.211.211 0 00.214-.208V3.333c0-.345.288-.625.643-.625z"
 style={{'--f-12-Z16GzhH': fill2}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}